import { Navigate, useLocation } from "react-router-dom";
import { useCimbeo } from "../../context";

function ProtectedRoute({ children }) {
  const { userToken } = useCimbeo();
  const location = useLocation();

  // Check if user exists and has a valid token
  if (!userToken) {
    // Redirect to the login page, but save the attempted location
    return <Navigate to="/authentication/sign-in" state={{ from: location }} replace />;
  }

  return children;
}

export default ProtectedRoute; 